import React, { useEffect, useState } from 'react';
import { MotionConfig } from 'framer-motion';
import { Toaster } from 'sonner';
import { GlobalHeader } from './components/sf/GlobalHeader';
import { AppNavBar } from './components/sf/AppNavBar';
import { ParityBanner } from './components/sf/ParityBanner';
import { CompPlanAdmin } from './pages/CompPlanAdmin';
import { HowCommissionsWork } from './pages/HowCommissionsWork';
import { LoanCommission } from './pages/LoanCommission';
import { LoStatement } from './pages/LoStatement';
import { PeriodClose } from './pages/PeriodClose';
import { ScreenId } from './types/navigation';
interface AppProps {
  /** Preview the Comp Plan screen as a Commission Rule Editor (Marvin Yaldo) or a read-only user. */
  viewerIsRuleEditor?: boolean;
}
export function App({
  viewerIsRuleEditor = true
}: AppProps) {
  const [screen, setScreen] = useState<ScreenId>('how');
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, [screen]);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3ijxpcqos80jw">
      <div className="min-h-screen w-full bg-sf-bg font-sans text-sf-text" data-id="element-1" data-mp="3iiweam7rne26">
        <Toaster position="top-center" toastOptions={{
        style: {
          fontSize: '13px'
        }
      }} data-id="element-2" data-mp="3ml14tc2x3ukl" />
        <div className="sticky top-0 z-30" data-id="element-3" data-mp="3rc9i4j7dc031">
          <GlobalHeader data-id="element-4" data-mp="3rdkg22e4udm8" />
          <AppNavBar active={screen} onChange={setScreen} data-id="element-5" data-mp="3recdzjv7cnfo" />
        </div>
        <main id="app-screen" role="tabpanel" aria-labelledby={`nav-tab-${screen}`} className="mx-auto max-w-[1440px] space-y-3 p-3" data-id="element-6" data-mp="4n6o4eeqtbm">
          <ParityBanner data-id="element-7" data-mp="2zng0qi58cgrv" />
          {screen === 'how' && <HowCommissionsWork onNavigate={setScreen} data-id="element-8" data-mp="33nq6btp41567" />}
          {screen === 'plans' && <CompPlanAdmin canEditRules={viewerIsRuleEditor} data-id="element-9" data-mp="38l8hzruihyhw" />}
          {screen === 'loan' && <LoanCommission onNavigate={setScreen} data-id="element-10" data-mp="3dkuwe4m2tksa" />}
          {screen === 'statement' && <LoStatement data-id="element-11" data-mp="3dirw8rr7mb9u" />}
          {screen === 'close' && <PeriodClose onNavigate={setScreen} data-id="element-12" data-mp="nwc0jp6vnpuo" />}
        </main>
      </div>
    </MotionConfig>;
}